<template>
  <div v-if="show" class="loading">
    <div class="loader">
      <pulse-loader v-bind:loading="show"></pulse-loader>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
    name: 'Loading',
    props: {
        show: false
    },
    components: {
        'pulse-loader': PulseLoader
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .loading {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,.5);
  }
  .loader {
    position: absolute;
    top: 50%;
    left: 50%;
  }
</style>
